/* eslint-disable jsx-a11y/no-autofocus,null */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OpacityPreLoader from '../../PreLoaders/OpacityPreLoader';

const WAIT_AJAX = 800;
const MIN_LENGTH = 3;

class SearchAjaxSelect extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      searchValue: '',
      fixedSearchValue: '',
      typingTimeout: 0
    };
    this.inputRef = React.createRef();
  }

  getSelectValueTitle = () => {
    if (this.props.selectedValue.value) {
      return this.props.selectedValue.title;
    }
    return this.props.placeholder;
  };

  handleChange = event => {
    // Отправляем аякс чз секунду как перестал изменяться инпут
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    this.setState({
      searchValue: event.target.value,
      typingTimeout: setTimeout(() => {
        console.log(this.state);
        this.setState({ fixedSearchValue: this.state.searchValue });
        if (this.state.searchValue.length >= MIN_LENGTH) {
          this.props.handleReloadSelectOptions(this.state.searchValue.trim());
        }
      }, WAIT_AJAX)
    });
  };

  handleKeyDown = event => {
    if (event.key === 'Enter' && this.state.searchValue !== '') {
      clearTimeout(this.state.typingTimeout);
      this.props.handleReloadSelectOptions(this.state.searchValue.trim());
    }
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    if (newValue !== this.props.selectedValue) {
      this.props.handleChangeValue(newValue);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="btn-group bootstrap-select form-control">
          <button
            type="button"
            className="btn dropdown-toggle bs-placeholder btn-default"
            data-toggle="dropdown"
            title={this.getSelectValueTitle()}
            onClick={() => {
              this.inputRef.current.focus();
            }}
          >
            {this.getSelectValueTitle()}
          </button>
          <div
            className="dropdown-menu open"
            style={{
              maxHeight: '264px',
              overflow: 'hidden'
            }}
          >
            {this.props.ajaxInProcessed ? <OpacityPreLoader /> : null}
            <div style={{ padding: '4px 8px 9px' }}>
              <input
                ref={this.inputRef}
                type="text"
                placeholder={'Введите текст для поиска'}
                className="form-control"
                value={this.state.searchValue}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
              />
            </div>
            {this.props.selectArrItems.length > 0 ? (
              <ul
                className="dropdown-menu inner"
                role="listbox"
                aria-expanded="false"
                style={{
                  maxHeight: '252px',
                  overflowY: 'auto'
                }}
              >
                {this.props.selectArrItems.map(item => (
                  <li
                    key={item.title.toString()}
                    className={
                      this.props.selectedValue.value === item.value
                        ? 'active'
                        : ''
                    }
                  >
                    <a href="" onClick={e => this.changeValue(e, item)}>
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="alert-default text-center">
                {this.state.fixedSearchValue !== '' ? (
                  <p>Ничего не найдено :-(</p>
                ) : (
                  <p>Вы еще ничего не искали :-(</p>
                )}
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SearchAjaxSelect.defaultProps = {
  placeholder: null
};

SearchAjaxSelect.propTypes = {
  // IN PROPS
  placeholder: PropTypes.string,
  ajaxInProcessed: PropTypes.bool.isRequired,
  selectedValue: PropTypes.shape({
    value: PropTypes.any,
    title: PropTypes.string
  }).isRequired,
  selectArrItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleReloadSelectOptions: PropTypes.func.isRequired,
  handleChangeValue: PropTypes.func.isRequired
};

export default SearchAjaxSelect;



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/SearchAjaxSelect/SearchAjaxSelect.js